import config from '../nyConfig'
const ApiPublic = {
    "下载员工模板": new config({url: '/public/staffModel', showSuccessMessage: true, useToken: false }),
    "显示图片": new config({url: '/public/image', showSuccessMessage: true, useToken: false }),
    "上传图片": new config({url: '/public/uploadImage', showSuccessMessage: true, useToken: false }),
    "富文本上传图片": new config({url: '/public/editorUploadImage', showSuccessMessage: true, useToken: false }),
    "下载文件": new config({url: '/public/loadFile', showSuccessMessage: false, useToken: false }),
    "播放视频": new config({url: '/public/video', showSuccessMessage: false, useToken: false }),
    "上传视频": new config({url: '/public/uploadVideo', showSuccessMessage: true, useToken: false }),
    "意见反馈": new config({url: '/manager/listFeedback', showSuccessMessage: false, useToken: true }),
    "添加职业": new config({url: '/assess/addOccupationDic', showSuccessMessage: true, useToken: true }),
    "删除职业": new config({url: '/assess/delOccupationDic', showSuccessMessage: true, useToken: true }),
    "职业列表": new config({url: '/assess/listOccupationDic', showSuccessMessage: false, useToken: true }),
    "设置列表": new config({url: '/setting/list', showSuccessMessage: false, useToken: true }),
    "设置修改": new config({url: '/setting/edit', showSuccessMessage: false, useToken: true }),
}

export default ApiPublic
